/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import React from 'react';
import Container from '@mui/material/Container';
import Button from '@material-ui/core/Button';
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import { withTranslation } from 'react-i18next';
import { useThemeData } from '../../context/ThemeDataContext'
import GeneralText from "../../components/Fonts";

function HomeServiceRouteComponent(props) {
  const {font_family, font_family_button, primary_color_2, background_color_7,background_color_2} = useThemeData().themeData.site.theme;
  const setActive = props.setActive;
  const active = props.active;
  const style = ({
    activeStyle: {
      color: `${background_color_7}`,
    },
    passiveStyle: {
      color: `${background_color_2}`,
    }
  });

  return (
    <Container className="HomeServiceRoute page-edge"
      style={{
        fontFamily: `${font_family}`,
        color: `${primary_color_2}`
      }} >

      <div className="borderRoute">
        <Button onClick={() => setActive('routeOne')}
          style={{ fontFamily: `${font_family_button}`, color: `${active === 'routeOne' ? style.activeStyle.color : style.passiveStyle.color}` }}
          className="no-bttn-style">
          <GeneralText
                className="font-bold"
                color={primary_color_2}
                variant="subtitle2"
              >
                1. {props.t('Productchoice')}
            </GeneralText>
        </Button>
        <ArrowRightAltIcon
          style={{ width: "auto", height: "2rem", paddingBottom: '1vh' }}
        />
        <Button onClick={() => setActive('routeTwo')}
          disabled={active === 'routeOne'}
          style={{ fontFamily: `${font_family_button}`, color: `${active === 'routeTwo' ? style.activeStyle.color : style.passiveStyle.color}` }}
          className="no-bttn-style">
          <GeneralText
                className="font-bold"
                color={primary_color_2}
                variant="subtitle2"
              >
                2. {props.t('Upload')}
            </GeneralText>
        </Button>
        <ArrowRightAltIcon
          style={{ width: "auto", height: "2rem", paddingBottom: '1vh' }}
        />
        <Button onClick={() => setActive('routeThree')}
          disabled={active === 'routeOne' || active === 'routeTwo'}
          style={{ fontFamily: `${font_family_button}`, color: `${active === 'routeThree' ? style.activeStyle.color : style.passiveStyle.color}` }}
          className="no-bttn-style">
          <GeneralText
                className="font-bold"
                color={primary_color_2}
                variant="subtitle2"
              >
                3. {props.t('Order')}
            </GeneralText>
        </Button>
      </div>

    </Container>
  )

}

export default React.memo(withTranslation('HomeServiceRouteComponent')(HomeServiceRouteComponent));
